import React from 'react';
import { BrowserRouter as Router,Route} from 'react-router-dom';
import Index from '../components/app'

export default class HomeRoute extends React.Component {
    render(){
        return (
            <Router>
                <Route path="/" component={Index} />
            </Router>
        )
    } 
}


// WEBPACK FOOTER //
// ./src/pages/home/routes/index.js